<tui-textfield tuiTextfieldSize="s" style="width: 100%">
  <input
    tuiInputDateRange
    [formControl]="control"
    i18n-placeholder="@@VyberiteDaty" placeholder="Выберите даты"
  />
  <tui-calendar-range *tuiDropdown/>
</tui-textfield>
